import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {DialogDisclosure, DialogFooter} from '@/components/ui/dialog-atoms/DialogAtoms'
import {useTranslation} from '@/translations/i18n'
import {useDialogContext, useDialogStore} from '@ariakit/react'
import {AgendaEventStatusDropdown} from '../agenda-event-status-dropdown/AgendaEventStatusDropdown'
import {AgendaEventStatus} from '../../types'
import {SubmitErrorHandler, useFormContext} from 'react-hook-form'
import {EditEventFormValidationSchema} from '../../formSchemas'
import {useState} from 'react'
import {AgendaEditEventConfirmationDialog} from '../agenda-event-form/agenda-edit-event-confirmation-dialog/AgendaEditEventConfirmationDialog'
interface EditEventFormDialogFooterProps {
    eventStatus: AgendaEventStatus
    isRecurringEvent?: boolean
}

export const EditEventFormDialogFooter = ({
    eventStatus = 'scheduled',
    isRecurringEvent
}: EditEventFormDialogFooterProps) => {
    const {t} = useTranslation()
    const {handleSubmit, getValues, formState} = useFormContext<EditEventFormValidationSchema>()

    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = useState(false)

    const dialog = useDialogContext()
    const confirmationDialog = useDialogStore({
        open: isConfirmationDialogOpen,
        setOpen: setIsConfirmationDialogOpen
    })

    const handleUpdateEvent = () => {
        confirmationDialog.show()
    }

    const handleUpdateEventError: SubmitErrorHandler<EditEventFormValidationSchema> = errors => {
        console.error(errors, {values: getValues()})
    }

    const onSubmit = handleSubmit(handleUpdateEvent, handleUpdateEventError)

    return (
        <DialogFooter>
            <AgendaEventStatusDropdown eventStatus={eventStatus} />
            <Flexbox gap={2}>
                <DialogDisclosure store={dialog} render={<Button variant="secondary">{t('commons:cancel')}</Button>} />
                <Button variant="primaryNeutral" onClick={onSubmit}>
                    {t('commons:save')}
                </Button>
                {isConfirmationDialogOpen && (
                    <AgendaEditEventConfirmationDialog
                        confirmationDialog={confirmationDialog}
                        defaultValues={getValues()}
                        previousDate={formState.defaultValues?.date?.date}
                        isRecurringEvent={isRecurringEvent}
                        isToReschedule={formState.defaultValues?.status == 'to_reschedule'}
                    />
                )}
            </Flexbox>
        </DialogFooter>
    )
}
